class Employee {
    constructor() {
        this.id = 0;
        this.name = "";
        this.surname = "";
        this.email = "";
        this.password = "";
        this.role = "";
        this.active = false;
    }
}
export default Employee;